import { Flag } from 'lucide-react';

export function ReportBadge() {
  return (
    <div
      className="inline-flex items-center gap-1.5 flex-shrink-0"
      style={{
        minHeight: '22px',
        paddingLeft: '8px',
        paddingRight: '8px',
        paddingTop: '3px',
        paddingBottom: '3px',
        backgroundColor: 'var(--destructive-soft)',
        borderRadius: '9999px',
        border: '1px solid rgba(212, 24, 61, 0.2)',
      }}
    >
      <Flag 
        className="w-3.5 h-3.5" 
        style={{ 
          stroke: 'var(--destructive)',
          fill: 'none',
          strokeWidth: '2',
          width: '14px',
          height: '14px',
        }} 
      />
      <span
        style={{
          fontSize: 'var(--text-xs)',
          fontWeight: 'var(--font-weight-medium)',
          color: 'var(--destructive)',
          lineHeight: 'normal',
        }}
      >
        Denunciei
      </span>
    </div>
  );
}